"use strict";

import angular from "angular";
import SettingsController from "./settings.controller";

export default angular
  .module("dalApp.settings", [])
  .controller("SettingsController", SettingsController).name;



// WEBPACK FOOTER //
// ./client/app/account/settings/index.js